import React from 'react';
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const SearchAlerts = ({ searchAlerts }) => {
  const navigate = useNavigate(); // Initialize useNavigate

  // The searchAlerts prop is directly used, no internal state for alerts
  // If toggle/delete functionality is needed, it should be handled by dispatching actions to the Redux store
  // For now, these functions are placeholders or would trigger parent component updates.
  const toggleAlert = (alertId) => {
    console.log(`Toggle alert ${alertId}`);
    // Dispatch action to update Redux store
  };

  const deleteAlert = (alertId) => {
    console.log(`Delete alert ${alertId}`);
    // Dispatch action to delete from Redux store
  };

  return (
    <div className="bg-card rounded-lg border border-border p-6">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-semibold text-foreground">Search Alerts</h2>
        <Button
          variant="ghost"
          size="sm"
          iconName="Plus"
          iconPosition="left"
          onClick={() => navigate('/property-search-browse')}
        >
          Create Alert
        </Button>
      </div>
      {searchAlerts?.length === 0 ? (
        <div className="text-center py-8">
          <div className="w-16 h-16 bg-muted rounded-full flex items-center justify-center mx-auto mb-4">
            <Icon name="Bell" size={24} className="text-muted-foreground" />
          </div>
          <p className="text-muted-foreground mb-4">No search alerts set up</p>
          <Button
            variant="outline"
            iconName="Bell"
            iconPosition="left"
            onClick={() => navigate('/property-search-browse')}
          >
            Create Your First Alert
          </Button>
        </div>
      ) : (
        <div className="space-y-4">
          {searchAlerts?.map((alert) => (
            <div key={alert.id} className="border border-border rounded-lg p-4">
              <div className="flex items-start justify-between mb-3">
                <div className="flex-1">
                  <div className="flex items-center space-x-2 mb-1">
                    <Icon name="MapPin" size={14} className="text-muted-foreground" />
                    <span className="font-medium text-foreground">{alert.location}</span>
                    <span className={`px-2 py-1 rounded-full text-xs font-medium ${
                      alert.isActive 
                        ? 'bg-success/10 text-success' :'bg-muted text-muted-foreground'
                    }`}>
                      {alert.isActive ? 'Active' : 'Paused'}
                    </span>
                  </div>
                  <div className="flex items-center space-x-4 text-sm text-muted-foreground mb-2">
                    {alert.propertyType && (
                      <span className="capitalize">{alert.propertyType}</span>
                    )}
                    {alert.priceRange && (
                      <span>{alert.priceRange}</span>
                    )}
                    {alert.bedrooms && (
                      <span>{alert.bedrooms}+ beds</span>
                    )}
                  </div>
                  <p className="text-xs text-muted-foreground">
                    {alert.newMatches} new matches this week • Created {alert.createdDate}
                  </p>
                </div>
                <div className="flex items-center space-x-2">
                  <Button
                    variant="ghost"
                    size="sm"
                    iconName={alert.isActive ? "Pause" : "Play"}
                    onClick={() => toggleAlert(alert.id)}
                  />
                  <Button
                    variant="ghost"
                    size="sm"
                    iconName="Trash2"
                    onClick={() => deleteAlert(alert.id)}
                    className="text-error hover:text-error"
                  />
                </div>
              </div>
              
              {alert.newMatches > 0 && (
                <div className="bg-primary/5 border border-primary/20 rounded-lg p-3">
                  <div className="flex items-center space-x-2">
                    <Icon name="Bell" size={16} className="text-primary" />
                    <span className="text-sm font-medium text-primary">
                      {alert.newMatches} new properties match your criteria
                    </span>
                    <Button
                      variant="ghost"
                      size="sm"
                      className="ml-auto text-primary hover:text-primary"
                      onClick={() => navigate('/property-search-browse')}
                    >
                      View Matches
                    </Button>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default SearchAlerts;
